import styled from '@emotion/styled';

const Pills = styled('div')`
  display: flex;
  flex-wrap: wrap;
  font-size: ${p => p.theme.fontSizeSmall};
`;

export default Pills;
